import { createSlice } from "@reduxjs/toolkit";
import { sendOnPropertyChangeRequest } from "api-calls/SendOnFnolPropertyChangeRequest";

const initialState = {
  autoPopulationData: { standard: { byFieldPath: {} }, thirdParty: { byTPId: {} } },
  queuedTriggers: { thirdParty: { nextTrigger: null } },
};

const fnolOnPropertyChangeSlice = createSlice({
  name: "fnolOnPropertyChange",
  initialState: initialState,
  reducers: {
    updateOnPropertyChangeData(state, action) {
      const changes = action.payload;
      changes.forEach((change) => {
        state.autoPopulationData.standard.byFieldPath[change.fieldPath] = change;
      });
    },
    updateTPOnPropertyChangeData(state, action) {
      const changes = action.payload;
      changes.forEach((change) => {
        if (change.tpId && change.tpField) {
          if (state.autoPopulationData.thirdParty.byTPId[change.tpId]) {
            state.autoPopulationData.thirdParty.byTPId[change.tpId][change.tpField] = change;
          } else {
            state.autoPopulationData.thirdParty.byTPId[change.tpId] = {
              [change.tpField]: change,
            };
          }
        }
      });
    },
    queueNextTPTrigger(state, action) {
      state.queuedTriggers.thirdParty.nextTrigger = action.payload;
    },
    resetOnPropertyChangeData(state, action) {
      return initialState;
    },
    resetOnPropertyChangeDataForField(state, action) {
      delete state.autoPopulationData.standard.byFieldPath[action.payload.fieldPath];
    },
  },
});

export default fnolOnPropertyChangeSlice.reducer;

export const {
  updateOnPropertyChangeData,
  updateTPOnPropertyChangeData,
  queueNextTPTrigger,
  resetOnPropertyChangeData,
  resetOnPropertyChangeDataForField,
} = fnolOnPropertyChangeSlice.actions;

export const fireOnPropertyChange = (fieldPath, fnolInstance, options = {}) => {
  return async function fireOnPropertyChangeThunk(dispatch, getState) {
    await sendOnPropertyChangeRequest(fieldPath, fnolInstance, dispatch, getState, options);
  };
};
